"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethods = exports.PaymentMethodName = exports.PaymentMethodIssuer = exports.PaymentMethodType = exports.PaymentMethodIntegration = void 0;
var Colors_1 = __importDefault(require("./Colors"));
var Salesforce_1 = require("../Constants/Salesforce");
var PaymentMethodIntegration;
(function (PaymentMethodIntegration) {
    PaymentMethodIntegration["Paygreen"] = "paygreen";
    PaymentMethodIntegration["Stripe"] = "stripe";
    PaymentMethodIntegration["Edenred"] = "edenred";
    PaymentMethodIntegration["Swile"] = "swile";
})(PaymentMethodIntegration || (exports.PaymentMethodIntegration = PaymentMethodIntegration = {}));
var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["BankCard"] = "bank_card";
    PaymentMethodType["RestaurantCard"] = "restaurant_card";
})(PaymentMethodType || (exports.PaymentMethodType = PaymentMethodType = {}));
var PaymentMethodIssuer;
(function (PaymentMethodIssuer) {
    PaymentMethodIssuer["NatixisIntertitres"] = "natixis-intertitres";
    PaymentMethodIssuer["SodexoPassFrance"] = "sodexo-pass-france";
    PaymentMethodIssuer["UpFranceChequeDejeuner"] = "up-france-cheque-dejeuner";
    PaymentMethodIssuer["Stripe"] = "stripe";
    PaymentMethodIssuer["Edenred"] = "edenred";
    PaymentMethodIssuer["Swile"] = "swile";
    PaymentMethodIssuer["PaygreenCard"] = "";
})(PaymentMethodIssuer || (exports.PaymentMethodIssuer = PaymentMethodIssuer = {}));
var PaymentMethodName;
(function (PaymentMethodName) {
    PaymentMethodName["Bimpli"] = "bimpli";
    PaymentMethodName["Edenred"] = "edenred";
    PaymentMethodName["PaygreenBankCard"] = "paygreen_bank_card";
    PaymentMethodName["Pluxee"] = "pluxee";
    PaymentMethodName["PluxeeAlias"] = "sodexo";
    PaymentMethodName["Stripe"] = "stripe";
    PaymentMethodName["StripeAlias"] = "cartes-bancaires";
    PaymentMethodName["Swile"] = "swile";
    PaymentMethodName["Up"] = "up";
})(PaymentMethodName || (exports.PaymentMethodName = PaymentMethodName = {}));
exports.PaymentMethods = {
    Bimpli: {
        name: PaymentMethodName.Bimpli,
        label: 'carte Bimpli (ex Apetiz)',
        title: 'Carte Bimpli (ex Apetiz)',
        abbr: 'Bimpli',
        type: PaymentMethodType.RestaurantCard,
        integration: PaymentMethodIntegration.Paygreen,
        issuer: PaymentMethodIssuer.NatixisIntertitres,
        colors: {
            primary: Colors_1.default.bimpli, secondary: Colors_1.default.bimpliAlt, tertiary: Colors_1.default.bimpliAlt2,
        }
    }, Edenred: {
        name: PaymentMethodName.Edenred,
        label: 'carte Ticket Restaurant® Edenred',
        title: 'Carte Edenred',
        abbr: 'Edenred',
        readmoreLink: Salesforce_1.SALESFORCE_ARTICLE_EDENRED_URL,
        sav: Salesforce_1.SALESFORCE_ARTICLE_EDENRED_URL,
        helpers: {
            login: "\n      En cliquant sur le bouton \"Connecter\", vous allez \u00EAtre redirig\u00E9 vers le site MyEdenred.<br>\n      Saisissez votre email et votre mot de passe, puis validez les \u00E9tapes suivantes.<br>\n      Une fois toutes ces \u00E9tapes valid\u00E9es, vous serez connect\u00E9 \u00E0 votre carte Edenred et pourrez commencer \u00E0 l'utiliser.\n    ", logout: "\n      Votre carte Edenred sera d\u00E9connect\u00E9e et ne sera plus d\u00E9bit\u00E9e.\n      Vous devrez vous reconnecter pour l'utiliser \u00E0 nouveau.\n    ", setDefault: "\n      J'utilise automatiquement le solde de ma carte Edenred pour toutes mes commandes \u00E0 venir.\n      Pour chaque commande en mode Abonnement, j'autorise Potager City \u00E0 pr\u00E9lever le\n      solde au moment de la g\u00E9n\u00E9ration de la commande (la veille de la livraison).\n    ", subscriptionOrder: "\n      Au moment du paiement de votre commande, nous pr\u00E9l\u00E8verons en priorit\u00E9 sur votre carte Edenred.\n      Si le solde est insuffisant ou le plafond d\u00E9pass\u00E9, nous pr\u00E9l\u00E8verons la diff\u00E9rence sur votre carte bancaire.\n      Dans cette \u00E9ventualit\u00E9, nous avons effectu\u00E9 une autorisation sur votre carte bancaire du montant total de\n      votre commande.\n    ",
        },
        type: PaymentMethodType.RestaurantCard,
        integration: PaymentMethodIntegration.Edenred,
        issuer: PaymentMethodIssuer.Edenred,
        colors: {
            primary: Colors_1.default.edenred, secondary: Colors_1.default.edenredAlt, tertiary: Colors_1.default.edenredAlt2,
        }
    }, PaygreenBankCard: {
        name: PaymentMethodName.PaygreenBankCard,
        label: 'carte bancaire',
        title: 'Carte bancaire',
        abbr: 'CB',
        type: PaymentMethodType.BankCard,
        integration: PaymentMethodIntegration.Paygreen,
        issuer: PaymentMethodIssuer.PaygreenCard,
        colors: {
            primary: Colors_1.default.visa, secondary: Colors_1.default.visaAlt, tertiary: Colors_1.default.visaAlt2,
        }
    }, Pluxee: {
        name: PaymentMethodName.Pluxee,
        alias: PaymentMethodName.PluxeeAlias,
        label: 'carte Pluxee (ex Sodexo)',
        title: 'Carte Pluxee (ex Sodexo)',
        abbr: 'Pluxee',
        type: PaymentMethodType.RestaurantCard,
        integration: PaymentMethodIntegration.Paygreen,
        issuer: PaymentMethodIssuer.SodexoPassFrance,
        colors: {
            primary: Colors_1.default.pluxee, secondary: Colors_1.default.pluxeeAlt, tertiary: Colors_1.default.pluxeeAlt2,
        }
    }, Stripe: {
        name: PaymentMethodName.Stripe,
        alias: PaymentMethodName.StripeAlias,
        label: 'carte bancaire',
        title: 'Carte bancaire',
        abbr: 'CB',
        type: PaymentMethodType.BankCard,
        integration: PaymentMethodIntegration.Stripe,
        issuer: PaymentMethodIssuer.Stripe,
        colors: {
            primary: Colors_1.default.visa, secondary: Colors_1.default.visaAlt, tertiary: Colors_1.default.visaAlt2,
        }
    }, Swile: {
        name: PaymentMethodName.Swile,
        label: 'carte Swile',
        title: 'Carte Swile',
        abbr: 'Swile',
        readmoreLink: Salesforce_1.SALESFORCE_ARTICLE_SWILE_URL,
        helpers: {
            login: "\n      En cliquant sur le bouton \"Connecter\", vous allez \u00EAtre redirig\u00E9 vers le site de Swile.<br>\n      Saisissez votre email et votre mot de passe, puis validez les \u00E9tapes suivantes.<br>\n      Une fois toutes ces \u00E9tapes valid\u00E9es, vous serez connect\u00E9 \u00E0 votre carte Swile et pourrez commencer \u00E0 l'utiliser.\n    ",
            logout: "\n      Votre carte Swile sera d\u00E9connect\u00E9e et ne sera plus d\u00E9bit\u00E9e.\n      Vous devrez vous reconnecter pour l'utiliser \u00E0 nouveau.\n    ",
            setDefault: "\n      J'utilise automatiquement le solde de ma carte Swile pour toutes mes commandes \u00E0 venir.\n      Pour chaque commande en mode Abonnement, j'autorise Potager City \u00E0 pr\u00E9lever le\n      solde au moment de la g\u00E9n\u00E9ration de la commande (la veille de la livraison).\n    ",
            subscriptionOrder: "\n      Au moment du paiement de votre commande, nous pr\u00E9l\u00E8verons en priorit\u00E9 sur votre carte Swile.\n      Si le solde est insuffisant ou le plafond d\u00E9pass\u00E9, nous pr\u00E9l\u00E8verons la diff\u00E9rence sur votre carte bancaire.\n      Dans cette \u00E9ventualit\u00E9, nous avons effectu\u00E9 une autorisation sur votre carte bancaire du montant total de\n      votre commande.\n    ",
        },
        type: PaymentMethodType.RestaurantCard,
        integration: PaymentMethodIntegration.Swile,
        issuer: PaymentMethodIssuer.Swile,
        colors: {
            primary: Colors_1.default.swile, secondary: Colors_1.default.swileAlt, tertiary: Colors_1.default.swileAlt2,
        }
    }, Up: {
        name: PaymentMethodName.Up,
        label: 'carte Up',
        title: 'Carte Up',
        abbr: 'Up',
        type: PaymentMethodType.RestaurantCard,
        integration: PaymentMethodIntegration.Paygreen,
        issuer: PaymentMethodIssuer.UpFranceChequeDejeuner,
        colors: {
            primary: Colors_1.default.up, secondary: Colors_1.default.upAlt, tertiary: Colors_1.default.upAlt2,
        }
    },
};
exports.default = exports.PaymentMethods;
//# sourceMappingURL=PaymentMethods.js.map